import { ParsedUrlQuery } from "querystring"
import { useContext } from "react"
import { EnvContext } from "../components/EnvContext"

export const getIsPublic = (query: ParsedUrlQuery) => {
  return query.__public === "true"
}

export const useIsPublic = () => {
  const env = useContext(EnvContext)
  if (!env) throw new Error("EnvContext not found")
  return env.isPublic
  // const [isLocation, setIsLocation] = useState(false)
  // useEffect(() => {
  //   setIsLocation(location.pathname.indexOf("/publiek") === 0)
  // }, [])
  // const router = useRouter()
  // return getIsPublic(router.query) || isLocation
}
